export function settingsGuideValidate(settings_guide){
    var result = true;
    result = validateOwner(settings_guide.owner);
    result = validateFees(settings_guide.fees); 

    return result;
}

function validateOwner(owner){
    const num = Number(owner);
    return Number.isInteger(num);
}

function validateFees(fees){
    return fees &&
    typeof fees === 'object' &&
    fees.general_configuration &&
    typeof fees.general_configuration === 'object' &&
    validateFloatNumber(fees.general_configuration.monthly_shipping_limit) &&
    validateFloatNumber(fees.general_configuration.unpaid_guides_limit) &&
    validateShippingService(fees, "fedex") &&
    validateShippingService(fees, "ihs") &&
    validateShippingService(fees, "afimex") && 
    validateShippingService(fees, "ups") 
}

function validateFloatNumber(n){
    const num = Number(n);
    return !isNaN(num) && isFinite(num);
}

function validateShippingService(fees, ss) {
    if (fees[ss] == null) return true
    else if((fees[ss] && 
    typeof fees[ss] == 'object' &&
    validateFloatNumber(fees[ss].address_correction) &&
    validateFloatNumber(fees[ss].saturday_pickup) &&
    validateFloatNumber(fees[ss].extra_large_package) &&
    validateFloatNumber(fees[ss].kilo_extra) &&
    validateFloatNumber(fees[ss].insurance))) return true;

    return false;
}